export default __webpack_public_path__ + "static/media/perks-program-2x.74181d7e.png";